import { EncrdecrService } from './../Auth/encrdecr.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { MainHeaderMenuService } from '../services/main-header-menu.service';
import { CustomLoaderService } from '../services/custom-loader.service';
import { ClientDataService } from './../services/client-data.service';
import { environment } from 'src/environments/environment';
declare var $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  IsSubscribed = environment.IsSubscribed;

  Companyname: string = environment.CompayName;
  IsInvestor: boolean = false;
  LoginForm: FormGroup;
  LoginSubmitted: boolean = false;
  UserType: number = 2;
  IsShowLoginOption: boolean = true;
  IsMobile: boolean = false;
  DOE: any;
  IsOptimoney: boolean = environment.IsOptimoney;
  FIFO: string;
  DownloadLink: string;
  constructor(
    private LoginService: LoginService,
    private EncrdecrService: EncrdecrService,
    public ShowHideHeaderMenu: MainHeaderMenuService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private Loader: CustomLoaderService,
    private ClientDataService: ClientDataService
  ) {
    this.LoginForm = this.formBuilder.group({
      Username: ['', Validators.required],
      Password: ['', [Validators.required]],
      SB_ID: ['']
    });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  checkIsSignup() {
    setInterval(() => {
      if (sessionStorage.getItem('lkighty445dh==IsSignUp') == 'Y') {
        this.IsSubscribed = environment.IsSubscribed = true;
      } else {
        this.IsSubscribed = environment.IsSubscribed = false;
      }
    }, 500);
  }
  ngOnInit() {
    debugger;
    this.SetViewPort(window.innerWidth); //added by adarsh 27/02/2025
    this.checkIsSignup();
    this.Loader.show(); //added by adarsh 09/10/2023
    if (!this.IsOptimoney) {
      this.DownloadLink = sessionStorage.getItem('ihjt45h45=t');
    }
    this.SetViewPort(window.innerWidth);
    const CorporateFag = sessionStorage.getItem('Vbhs@#%LMKIo=');
    this.DOE = sessionStorage.getItem('lkighty445dh==8');
    this.FIFO = sessionStorage.getItem('lkighty445dh==9');

    let tempPath = location.pathname.split('/');
    if (tempPath[2] == 'investor') {
      this.UserType = 3;
      this.IsInvestor = true;
      this.IsShowLoginOption = false;
    } else {
      this.UserType = 2;
      this.IsInvestor = false;
      this.IsShowLoginOption = true;
    }
    $('.MainOuter').css('min-height', window.innerHeight - 50);
    //this.ShowHideHeaderMenu.hide();
    sessionStorage.removeItem('DashboardData'); // added by adarsh 06012025
    sessionStorage.removeItem('F44sGAGh2xwkpUL'); //Session_SubBrokerId
    sessionStorage.removeItem('Hldq31TLYwRbLJ8'); //Session_SubBrokerCode
    sessionStorage.removeItem('UZT6qHaDZSz66kx'); //Session_ClientBasicInfoId
    sessionStorage.removeItem('N1QJHdOkO7Hz8QC'); //Session_ClientBasicInfoId
    sessionStorage.removeItem('L2D3506kIHSk3E0'); //Session_UserType
    sessionStorage.removeItem('pOWgAF62qFXnZMn'); // Session_Razor
    sessionStorage.removeItem('W113TKilrF1u1gL'); // ucc code - client
    sessionStorage.removeItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    sessionStorage.removeItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294');
    // sessionStorage.removeItem('E#$%#XCha7%*=');
    // sessionStorage.removeItem('Vbhs@#%LMKIo=');
    // }
    // else{
    //    this.router.navigateByUrl("**");

    // }
    this.Loader.hide(); //added by adarsh 09/10/2023
  }
  OpenModalForAppQR() {
    this.CallAppQRModal();
  }
  CallAppQRModal() {
    $('#AppQRModal').modal({ backdrop: 'static', keyboard: false });
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }
  get r() {
    return this.LoginForm.controls;
  }
  onSubmit() {
    debugger;
    this.Loader.show(); //added by adarsh 03052023
    let Domain_Name = window.location.hostname;
    this.LoginSubmitted = true;
    if (this.LoginForm.invalid) {
      this.Loader.hide(); //added by adarsh 03052023
      return;
    }
    //   if(!this.IsOptimoney){
    //     if (this.FIFO != "Y" )
    //     {
    //       if (this.DOE == "N")
    //        {
    //         this.Loader.hide(); //added by adarsh 03052023
    //         this.CallAlertModal("Access denied !!");
    //         // window.location.reload();
    //         //this.router.navigateByUrl('');
    //         return;
    //       }
    //   }
    //   else {
    //     this.Loader.hide(); //added by adarsh 03052023
    //     this.CallAlertModal(
    //       "Access denied! Portfolio refresh and other mainteinance activity in progress. Please check after 30-60 minutes."
    //     );
    //     // window.location.reload();
    //     return;
    //   }
    // }

    debugger;
    // ////////
    //alert("Login Successfully");
    this.Loader.show();

    // if (this.UserType == 3) {
    if (this.IsOptimoney) {
      this.LoginForm.controls['SB_ID'].setValue('000000');
    } else {
      this.LoginForm.controls['SB_ID'].setValue(
        sessionStorage.getItem('ihjt45h45=p')
      );
    }
    sessionStorage.setItem(
      'Abodhj#@jdkd/%^82ncdbcnggshd!@#$',
      this.EncrdecrService.setEncr('0')
    );
    // }
    let DataBody = JSON.stringify(this.LoginForm.value);
    sessionStorage.setItem('Tgsh@#3734fjfskshh==', '173.212.234.56');
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    this.LoginService.PostLoginInfo(
      DataBody,
      this.UserType,
      IpAddress
    ).subscribe(
      (res: any) => {
        debugger;
        if (res.SubBrokerCode != '' && res.SubBrokerCode != null) {
          // console.log(res);
          if (this.IsOptimoney || environment.CompayName == 'IFA') {
            if (res.FIFO != 'Y') {
              if (res.DOE == 'N') {
                this.Loader.hide(); //added by adarsh 03052023
                this.CallAlertModal('Access denied !!');
                // window.location.reload();
                //this.router.navigateByUrl('');
                return;
              }
            } else {
              this.Loader.hide(); //added by adarsh 03052023
              this.CallAlertModal(
                'Access denied! Portfolio refresh and other mainteinance activity in progress. Please check after 30-60 minutes.'
              );
              // window.location.reload();
              return;
            }
          }
          if (this.UserType == 3) {
            sessionStorage.setItem(
              '@SWPFLAG',
              this.EncrdecrService.setEncr(res.SWPFlag)
            ); //SWPFlag
            sessionStorage.setItem(
              '@STPFLAG',
              this.EncrdecrService.setEncr(res.STPFlag)
            ); //STPFlag
            sessionStorage.setItem(
              '@SwitchFlag',
              this.EncrdecrService.setEncr(res.SwitchFlag)
            ); //SwitchFlag
            sessionStorage.setItem(
              '@RedeemFlag',
              this.EncrdecrService.setEncr(res.RedeemFlag)
            ); //RedeemFlag
          }
          sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
          sessionStorage.setItem(
            '5V5uSYBoBVqAvBIBqUEBhv6ELFF',
            this.EncrdecrService.setEncr('1')
          ); //Session_SubBrokerId

          sessionStorage.setItem(
            'F44sGAGh2xwkpUL',
            this.EncrdecrService.setEncr(res.LOGIN_ID)
          ); //Session_SubBrokerId
          sessionStorage.setItem(
            'V4WGROuLLBE6t98',
            this.EncrdecrService.setEncr(res.USER_NAME)
          ); //Session_UserName
          sessionStorage.setItem(
            'V8hpPfITcxhEI9x',
            this.EncrdecrService.setEncr(res.EMAIL_ID)
          ); //Session_UserEmail of subbroker
          sessionStorage.setItem(
            'Xe003SRRyYEoOC2',
            this.EncrdecrService.setEncr(res.MOBILE)
          ); //Session_UserMobile
          if (
            res.RazorCustId !== null &&
            res.RazorCustId !== undefined &&
            res.RazorCustId !== 'null'
          ) {
            sessionStorage.setItem(
              'pOWgAF62qFXnZMn',
              this.EncrdecrService.setEncr(res.RazorCustId)
            ); //RazorCustId
          } else {
            sessionStorage.setItem('pOWgAF62qFXnZMn', ''); //RazorCustId
          }
          sessionStorage.setItem(
            'Hldq31TLYwRbLJ8',
            this.EncrdecrService.setEncr(res.SubBrokerCode)
          ); //Session_SubBrokerCode
          sessionStorage.setItem(
            'L2D3506kIHSk3E0',
            this.EncrdecrService.setEncr(res.USER_TYPE)
          ); //Session_UserType
          sessionStorage.setItem(
            'qAkZrQYLWNBSlki',
            this.EncrdecrService.setEncr(res.LOGIN_ID)
          ); //Session_CBId

          sessionStorage.setItem('pi4ZU2P3M8JE4q7', res.Companylogobase64); //Session_B64CompanyLogo

          //sessionStorage.setItem('Session_B64CompanyLogo_EtE',res.Companylogobase64);
          if (res.Family_ID != null && res.Family_ID != undefined) debugger;
          sessionStorage.setItem(
            'hn0bHyGhfpGtrPe',
            this.EncrdecrService.setEncr(res.Family_ID)
          ); //Session_Family_ID

          sessionStorage.setItem('Session_Exchange', res.Exchange);
          sessionStorage.setItem('Session_Cobranding', res.Cobranding); //added by adarsh
          if (res.Cobranding == 'Y') {
            environment.IsSubscribed = true; //added this for testing once it is rectify then we change the publish condition.  for optimoney plus and optimoney
          }
          sessionStorage.setItem('ihjt45h45=sb', res.SubBrokerCode); //added by adarsh for optimoney
          sessionStorage.setItem('ihjt45h45=p', res.SubBrokerCode); //added by adarsh for Optimoney
          sessionStorage.setItem('lkighty445dh==AppName', res.AppName);
          sessionStorage.setItem('ihjt45h45=CompanyName', res.AppName);
          sessionStorage.setItem('lkighty445dh==CompanyAppName', res.AppName);
          sessionStorage.setItem('lkighty445dh==RegNo', res.RegNo);
          sessionStorage.setItem('lkighty445dh==FromDate', res.FromDate);
          sessionStorage.setItem('lkighty445dh==ToDate', res.ToDate);
          //alert('Exchange = ' + res.Exchange);

          this.Loader.hide();
          sessionStorage.setItem('ShowHeader', 'true');
          switch (res.USER_TYPE) {
            case '2':
              sessionStorage.setItem(
                'm5JkoXISmYRAIuY',
                this.EncrdecrService.setEncr(res.SubBrokerCode)
              ); //Session_UserId
              sessionStorage.setItem(
                'N1QJHdOkO7SBNAME8QC',
                this.EncrdecrService.setEncr(res.USER_NAME)
              ); //Session_SubbrokerName added by adarsh 27092023
              sessionStorage.setItem(
                'N1QJHdOkO7SBMb8QC',
                this.EncrdecrService.setEncr(res.MOBILE)
              ); //Session_SubbrokerMB added by adarsh 27092023

              sessionStorage.setItem('lkighty445dh==QR', res.UploadedQR);

              if (res.RazorePaymentStatus) {
                this.router.navigate(['/dashboard'], {
                  relativeTo: this.route
                });
              } else {
                // this.Loader.hide();
                //uncomment for payment
                sessionStorage.setItem(
                  'nbj%98LS74nkjsn~@&4njrkd`!kd*294',
                  res.RazorePaymentStatus
                );
                this.router.navigate(['/dashboard'], {
                  relativeTo: this.route
                });

                // sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', 'res.RazorePaymentStatus')
                // this.router.navigate(['/dashboard'], { relativeTo: this.route });
              }
              break;
            case '3':
              sessionStorage.setItem(
                'm5JkoXISmYRAIuY',
                this.EncrdecrService.setEncr(res.USER_ID)
              ); //Session_UserId
              sessionStorage.setItem(
                'UZT6qHaDZSz66kx',
                this.EncrdecrService.setEncr(res.LOGIN_ID)
              ); //Session_ClientBasicInfoId
              sessionStorage.setItem(
                'N1QJHdOkO7Hz8QC',
                this.EncrdecrService.setEncr(res.LOGIN_ID)
              ); //Session_ClientBasicInfoId
              sessionStorage.setItem(
                'N1QJHdOkO7SBNAME8QC',
                this.EncrdecrService.setEncr(res.SubbrokerName)
              ); //Session_SubbrokerName added by adarsh 27092023
              sessionStorage.setItem(
                'N1QJHdOkO7SBMb8QC',
                this.EncrdecrService.setEncr(res.SubbrokerMb)
              ); //Session_SubbrokerMB added by adarsh 27092023
              sessionStorage.setItem(
                'RelationShipId',
                this.EncrdecrService.setEncr(res.RelationShipId)
              ); //Session_SubbrokerMB added by adarsh 16112023
              this.router.navigate(['/client-dashboard'], {
                relativeTo: this.route
              });
              break;
          }
        } else {
          this.CallAlertModal('Invalid username and password.');
        }
      },
      (err: any) => {
        //debugger;
        ////////
        //console.log(err)
        let rr = err.error;
        let er = rr.substring(1, rr.length - 1);
        let rk = er.split(', ');
        this.Loader.hide();
        if (rk[1].includes('Number of invalid login attempts')) {
          this.CallAlertModal(
            'Number of invalid login attempts. Your account is locked for 15 minutes'
          );
        } else {
          this.CallAlertLoginModal('Please enter valid username and password');
        }
        ////console.log('err =>' + er);
      }
    );

    this.Loader.hide();
  }
  //added by adarsh
  changeUsertype(UserType) {
    debugger;
    this.UserType = UserType;
    console.log(this.UserType);
    sessionStorage.setItem(
      'L2D3506kIHSk3E0',
      this.EncrdecrService.setEncr(this.UserType.toString())
    );
    //routerLink="/forgot-password"
  }
  ChangeType() {
    //////
    this.IsInvestor = !this.IsInvestor;
    if (this.IsInvestor) {
      this.UserType = 3;
    } else {
      this.UserType = 2;
    }
  }
  SendUserType() {
    console.log(this.UserType);
    sessionStorage.setItem(
      'L2D3506kIHSk3E0',
      this.EncrdecrService.setEncr(this.UserType.toString())
    );
    //routerLink="/forgot-password"
  }

  CallAlertModal(msg: any) {
    $('#AlertModal_Family').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContent_Family').text(msg);
  }
  CallAlertLoginModal(msg: any) {
    $('#AlertLoginModal').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertLoginModalContent').text(msg);
  }

  // CallAlertModal(msg: any)
  //   $("#AlertModal").modal({
  //     backdrop: 'static',
  //     keyboard: false
  //   });
  //   $('#AlertModalContent').text(msg);
  // }
  getCompanyDetails() {
    if (this.FIFO != 'Y') {
      if (this.DOE == 'N') {
        this.Loader.hide(); //added by adarsh 03052023
        this.CallAlertModal('Access is denied !!!');
        this.router.navigateByUrl('');
        return;
      } else {
        this.ClientDataService.getCompanyDetails(
          environment.CompanyId
        ).subscribe((data: any) => {
          if (data != null && data.ArrayOfResponse.length != 0) {
            sessionStorage.setItem(
              'E#$%#XCha7%*=',
              data.ArrayOfResponse[0].Dummy2
            );
            sessionStorage.setItem(
              'Vbhs@#%LMKIo=',
              data.ArrayOfResponse[0].Dummy1
            );
          }
        });
      }
    } else {
      this.Loader.hide(); //added by adarsh 03052023
      this.CallAlertModal(
        'Access denied! Portfolio refresh and other mainteinance activity in progress. Please check after 30-60 minutes.'
      );

      // window.location.reload();
      return;
    }
  }
}
